/**
 * show key 组件
 */

import React from 'react';
import classNames from 'classnames';

import { messenger } from '../../utils/Messenger';
import './ShowKey.less';

function addLoadEvent(func) {
  const oldOnload = window.onload;
  if (typeof window.onload !== 'function') {
    window.onload = func;
  } else {
    window.onload = () => {
      oldOnload();
      func();
    };
  }
}

class ShowKey extends React.Component {
  constructor(props) {
    super(props);

    addLoadEvent(() => {
      const showKey = document.getElementById('showKey');
      showKey.onmousedown = (ev) => {
        const oEvent = ev || window.event;

        const distanceX = oEvent.clientX - showKey.offsetLeft;
        const distanceY = oEvent.clientY - showKey.offsetTop;

        document.onmousemove = (ev1) => {
          const oEvent1 = ev1 || window.event;
          showKey.style.left = `${oEvent1.clientX - distanceX}px`;
          showKey.style.top = `${oEvent1.clientY - distanceY}px`;
        };
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        oEvent.cancelBubble = true;
        oEvent.stopPropagation();
      };
    });
  }

  showKey = () => {
    const current = window.showKey;
    messenger.postMessage('showKey', !current);
  };

  render() {
    const current = window.showKey;
    const switchClassName = classNames('switch', {
      on: current,
    });
    const switchBarClassName = classNames('switch-bar', {
      on: current,
    });

    return (
      <div id="showKey" className={`switch-con ${current ? 'on' : ''}`}>
        <div className={switchClassName} onClick={this.showKey}>
          {current ? (
            <div className="switch-on">OFF</div>
          ) : (
            <div className="switch-off">ON</div>
          )}
          <div className={switchBarClassName} />
        </div>
      </div>
    );
  }
}

export default ShowKey;
